import { getLockStatusDescription } from "../../../../sightlines-shared/utils/functions";

export interface ICapitalRenewalStatus {
    currentYear: number,
    lockStatus: number,
    lockStatusDescription: string
}

export class CapitalRenewalStatus implements ICapitalRenewalStatus {
    currentYear: number;
    lockStatus: number;
    lockStatusDescription: string;

    constructor(init?: Partial<CapitalRenewalStatus>) {
        this.currentYear = init.currentYear;
        this.lockStatus = init.lockStatus;
        this.lockStatusDescription = getLockStatusDescription(init.lockStatus);
    }
}
